import React, { useCallback } from 'react';
import { MULTIPLE_CARD } from 'src/sections/GroupCards/cardTypes';
import MultipleCrossSimpleBarChart from './echarts/Simple/BarChart';
import MultipleCrossSimplePieChart from './echarts/Simple/PieChart';

/**
 * @param {string} type type of the chart that will be rendered.
 * where type = pie|bar
 */
function getMultipleCrossChart(type = 'pie') {
  return {
    pie: MultipleCrossSimplePieChart,
    bar: MultipleCrossSimpleBarChart,
  }[type];
}

export default function MultipleCrossChart({
  type,
  data,
  colors,
  chartFontSize,
  colorPickerColors,
  legendsFilter,
  legendsFilterHandler,
  theme,
  themeTitle,
  updateChartColors,
  error,
  chartRef,
}) {
  const MultipleCrossChartComponent = getMultipleCrossChart(type);

  const renderMultipleCrossChartComponent = useCallback(() => {
    return (
      <MultipleCrossChartComponent
        data={data}
        fontSize={chartFontSize}
        legendsFilter={legendsFilter}
        legendsFilterHandler={legendsFilterHandler}
        theme={{ ...theme, colors }}
        updateChartColors={updateChartColors}
        key={`${theme.title}${error}`}
        colorPickerColors={colorPickerColors}
        themeTitle={themeTitle}
        error={error}
        chartType={type}
        cardType={MULTIPLE_CARD}
        chartRef={chartRef}
      />
    );
  }, [
    type,
    data,
    colors,
    chartFontSize,
    colorPickerColors,
    legendsFilter,
    legendsFilterHandler,
    theme,
    themeTitle,
    updateChartColors,
    error,
    chartRef,
  ]);

  return (
    <>
      {renderMultipleCrossChartComponent()}
    </>
  );
}
